module.exports = __webpack_public_path__ + "img/social01.39bdde41.svg";